module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.option1) ? _c('ESchart', {
    attrs: {
      "height": "50vh",
      "option": _vm.option1,
      "id": "chart1"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.option2) ? _c('ESchart', {
    attrs: {
      "height": "50vh",
      "option": _vm.option2,
      "id": "chart2"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23da951a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Homepage/Home.vue
// module id = 754
// module chunks = 2